module.exports = __webpack_public_path__ + "duo_70x70.e2baf65d97a5d6f2c083e14d4717ccf4.png";